/* Redux */
import Redux from '../../Wunschliste.Redux'

/* Components */
import Item from './Item'

const WunschlisteInhalt = () => {
  const { items, products } = Redux()

  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
  return <>
    {Object.entries(items).map((item) => {
      const [key] = item
      const product = products.find(p=>p.key===key)
      if (!product) return null

      return <Item 
        key={key}
        {...{
          item,
          product,
        }}
      />
    })}
  </>
  /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

}

export default WunschlisteInhalt
